import React, { Suspense, useEffect, useState } from 'react'
import './assets/styles/App.scss'
import 'antd/dist/antd.min.css'
import './assets/styles/custom.scss'
import './theme/ThemeSwitcher.css'
import './theme/baseModal.css'
import './theme/orderWorkflowModal.css'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { isLoggedIn } from './utils/userUtils'
import { getListMenuFail, getListMenuSuccess } from '@redux/ducks/menuDucks'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@redux/store'
import { processMobileMenu } from '@utils/menuUtils'
import * as userApi from '@api/userApi';
import Loadding from '@components/layout/Loadding'
import BasicLayout from '@components/layout/BasicLayout'
import generateRoutes, { fallbackRoutes } from './router'

const URL_LOGIN_ALL_SYSTEM = (process.env.REACT_APP_AUTH_URL || "http://localhost:3000") + '/login-all'

const App: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const [routes, setRoutes] = useState<any[]>(fallbackRoutes)
  
  // Lấy menu data từ Redux store
  const { webChucNangAll, webUrls } = useSelector((state: RootState) => state.menu)

  useEffect(() => {
    const currentRoute = routes.find((route) => route.path === location.pathname);
    if (currentRoute && currentRoute.title) {
      document.title = 'KHO - ' + currentRoute.title;
    } else {
      document.title = 'PHẦN MỀM KHO';
    }
  }, [location, routes]);

  useEffect(() => {
    fetchMyMenu()
  }, [])

  // Cập nhật routes khi menu data thay đổi
  useEffect(() => {
    if (webChucNangAll && webChucNangAll.length > 0) {
      try {
        const updatedRoutes = generateRoutes(webChucNangAll, webUrls)
        
        setRoutes(updatedRoutes)
      } catch (error) {
        setRoutes(fallbackRoutes)
      }
    }
  }, [webChucNangAll, webUrls, location.pathname])

  const fetchMyMenu = async () => {
    try {
      setIsLoading(true)
      const res: any = await userApi.getMyMenu()

      if (res.data && Array.isArray(res.data)) {
        const { webUrls, webChucNangs, webChucNangAll } = processMobileMenu(res.data)
        
        dispatch(getListMenuSuccess({
          webUrls: webUrls,
          webChucNangs: webChucNangs,
          webChucNangAll: webChucNangAll
        }))
      }
    } catch (error) {
      dispatch(getListMenuFail({
        webUrls: [],
        webChucNangs: [],
        webChucNangAll: []
      }))
    } finally {
      setIsLoading(false)
    }
  }

  // Hiển thị loading khi đang fetch menu data
  if (isLoading) {
    return <Loadding />
  }

  return (
    <Suspense fallback={<Loadding />}>
      <Switch>
        {routes.map(({ component: Component, path, exact, name, layout: Layout }) => (
          <Route
            key={name}
            exact={exact}
            path={path}
            render={(props: any) => {
              return (
                <Layout>
                  {isLoggedIn() ? (
                    path === '/login' ? (
                      <Redirect push to="/" />
                    ) : (
                      <Component {...props} />
                    )
                  ) : path === '/login' || path === '/privacy-policy' || path === '/developer/contact' ? (
                    <Component {...props} />
                  ) :
                    path.includes('setting-token') ? (
                      <Component {...props} />
                    ) : (
                      // <Redirect push to="/login" />
                      window.location.href = `${URL_LOGIN_ALL_SYSTEM}?hethong=kho&redirect_url=${location.pathname}`
                    )}
                </Layout>
              )
            }}
          />
        ))}
        {/* Fallback route - chỉ render khi không có route nào match */}
        <Route path="*" render={() => {
          return (
            <BasicLayout>
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>404 - Trang không tồn tại</h2>
              </div>
            </BasicLayout>
          )
        }} />
      </Switch>
    </Suspense>
  )
}

export default App
